
export default {
    name: 'HelloWorld',
    props: {
    },
    data: function(){
        return{
            mobile: [
                {
                    img: 'phone1.png',
                    right: false,
                    click: false,
                    text: 'Отличный выбор, но не подходит для жизни онлайн. Данная модель поддерживает мобильный интернет на скорости 2G до 364 Кбит/с. Еще в 2004 году такие гаджеты считались очень современными, ведь с их помощью можно было общаться в чатах, форумах и даже в популярном тогда ISQ. Загрузка 1 веб-страницы в 2G-сети занимает целую минуту, поэтому для комфортного интернет-серфинга лучше выбрать другую модель. ',
                },
                {
                    img: 'phone2.png',
                    right: false,
                    click: false,
                    text: 'Такие гаджеты были популярны в 2010 году, когда в Тамбове запустили 3G-интернет на скорости до 42 Мбит/с. В то время стали особенно популярны социальные сети «ВКонтакте» и Instagram. Однако и этого недостаточно для современного «цифрового» абонента.',
                },
                {
                    img: 'phone3.png',
                    right: true,
                    click: false,
                    text: '4G-гаджет – именно то, что тебе нужно. В сети LTE можно звонить по видеосвязи или смотреть фильмы онлайн – скорости до 100 Мбит/с позволяют работать даже с «тяжелым» контентом.  Кстати, сегодня жителям Тамбова доступны еще более высокие скорости онлайн-серфинга до 300 Мбит/с. (такие скорости стали доступны тамбовчанам в 2016 г., когда МегаФон запустил в областном центре технологию передачи данных LTE-Advanced). По исследованиям результатов замеров скорости мобильного интернета в Тамбове в приложении SpeedTest в IV Q 2018 г. компании Ookla, именно этот оператор связи признан лидером. Для тех, кто хочет пользоваться самым быстрым мобильным интернетом стоит выбрать смартфон категории LTE Cat6. '
                },
            ],
            checkMobile: false,
            mapObText: '',
            mapObTextClass: '',
            choose: false,
            mobileText: '',
            mapOb: [
                {
                    img: 'tur',
                    name: 'Сходить в кино',
                    text: 'Верно! Фильмы и сериалы онлайн доступны каждому в онлайн-кинотеатрах. Абоненты тарифов «Включайся!» МегаФона могут смотреть 50 ТВ-каналов и несколько фильмов в рамках «пакета».',
                    check: false,
                    bg: 'green',
                    right: true
                },
                {
                    img: 'bank',
                    name: 'Посетить банк',
                    text: 'Отлично. Большинство банковских операций можно решать онлайн. Кстати, оплачивать услуги (от ЖКХ до штрафов) и даже покупки в супермаркете сегодня можно средствами со счета мобильного, привязав к нему банковскую карту МегаФона. ',
                    check: false,
                    bg: 'green',
                    right: true
                },
                {
                    img: 'shop',
                    name: 'Отправиться на шоппинг',
                    text: 'В точку! Покупки онлайн можно совершать в сотнях магазинах мира. Кстати, больше трехсот самых популярных брендов можно найти на сервисе #Специи – удобство еще и в том, что, покупая здесь, абоненты МегаФона могут вернуть часть потраченных средств. ',
                    check: false,
                    bg: 'purple',
                    right: true
                },
                {
                    img: 'man_dog',
                    name: 'Выгулять собаку',
                    text: 'К сожалению, гулять с собакой придется самостоятельно.',
                    check: false,
                    bg: 'green',
                    right: false
                },
                {
                    img: 'mother',
                    name: 'Контролировать ребенка',
                    text: 'Все верно! Ты можешь контролировать перемещение детей с помощью услуги «Родительский контроль». В удобном приложении также можно следить за остатком на счете телефона ребенка, зарядом его мобильного и даже формировать «черный список» веб-ресурсов. ',
                    check: false,
                    bg: 'green',
                    right: true
                },
                {
                    img: 'kiosk',
                    name: 'Купить газету',
                    text: 'Верно. Новости онлайн давно доступны на экране смартфона. ',
                    check: false,
                    bg: 'green',
                    right: true
                },
                {
                    img: 'home',
                    name: 'Спланировать путешествие',
                    text: 'Правильно. Подобрать тур, оформить медицинскую страховку, заказать экскурсию, приобрести билеты на самолет, поезд или автобус, оплатить аренду жилья можно онлайн. А с помощью сервиса «МегаФон Путешествия» можно еще и вернуть до 6% от потраченного. ',
                    check: false,
                    bg: 'purple',
                    right: true
                },
                {
                    img: 'girl',
                    name: 'Заняться бегом',
                    text: 'Спорт онлайн вряд ли принесет ощутимый результат. Хотя программы для самостоятельных тренировок можно найти в интернете.',
                    check: false,
                    bg: 'purple',
                    right: false
                },
                {
                    img: 'game',
                    name: 'Послушать музыку',
                    text: 'Правильно. Плей-лист онлайн – давно не новшество.  Любимые треки можно составить как в социальных сетях, так и на других веб-ресурсах.',
                    check: false,
                    bg: 'purple',
                    right: true
                },
            ]
        }
    },
    watch: {
        choose: function(){
            setTimeout(
                ()=>{
                    var element = document.getElementById('result')
                    element.scrollIntoView({ behavior: 'smooth' })
                }
            , 400);
        }
    },
    computed: {
        checkMap: function(){
            var chr = false;
            var index;
            for(index = 0; index < this.mapOb.length; ++index){
                if(this.mapOb[index].right){
                    if(this.mapOb[index].check == true){
                        chr = true;
                    }
                    else{
                        chr = false;
                        break;
                    }
                }
            }
            if(chr){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods: {
        mapObClick: function(item){
            if(!item.check){
                if(item.right){
                    this.mapObTextClass = "text-white"
                }
                else{
                    this.mapObTextClass = "text-danger"
                }
                this.mapObText = item.text
            }
            item.check = true;
        },
        phoneClick: function(val){
            if(!this.checkMobile && !val.click){
                val.click = true;
                this.mobileText = val.text;
                if(val.right){
                    this.checkMobile = true;
                    setTimeout(
                        ()=>{
                            var element = document.getElementById('map-check')
                            element.scrollIntoView({ behavior: 'smooth' })
                        }
                        , 400
                    );
                    
                }
            }
        }
    }
}